// extracted by mini-css-extract-plugin
export default {"dropzone":"fileCropper_dropzone__gAqyt"};